import { useEffect, useRef } from 'react';

const SCRIPT_SRC = 'https://forma.tbank.ru/static/onlineScript.js';

const SHOP_ID = process.env.REACT_APP_TBANK_CREDIT_SHOP_ID || '';
const RAW_SHOWCASE_ID = process.env.REACT_APP_TBANK_CREDIT_SHOWCASE_ID || '';

const IS_TEST = String(process.env.REACT_APP_TBANK_CREDIT_TEST) === 'true';
const DEMO_FLOW = process.env.REACT_APP_TBANK_CREDIT_DEMO_FLOW || 'sms';
const SHOWCASE_ID = RAW_SHOWCASE_ID;
const PROMO_CODE = process.env.REACT_APP_TBANK_CREDIT_PROMOCODE || 'default';

const HAS_CREDENTIALS = Boolean(SHOP_ID && RAW_SHOWCASE_ID);

let scriptPromise = null;

const loadScript = () => {
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
        if (existing) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            scriptPromise = null;
            reject(new Error('Не удалось загрузить скрипт Т-Рассрочки'));
        };
        document.body.appendChild(script);
    });

    return scriptPromise;
};

const buildPaymentData = (order) => {
    const lineItems = Array.isArray(order?.line_items) ? order.line_items : [];

    const items = lineItems.map((li) => ({
        name: li.name || 'Товар',
        price: Math.round(Number(li.price) || 0),
        quantity: Number(li.quantity) || 1,
    }));

    const total = Math.round(Number(order?.total) || 0);
    const itemsSum = items.reduce((acc, it) => acc + it.price * it.quantity, 0);

    const diff = total - itemsSum;
    if (diff !== 0) {
        items.push({
            name: diff > 0 ? 'Доставка и сборы' : 'Скидка',
            price: diff,
            quantity: 1,
        });
    }

    const params = [];
    if (IS_TEST) {
        params.push(`demoFlow=${DEMO_FLOW}`);
    }
    items.forEach((it, i) => {
        params.push(`items.${i}.name=${it.name}`);
        params.push(`items.${i}.price=${it.price}`);
        params.push(`items.${i}.quantity=${it.quantity}`);
    });
    params.push(`promoCode=${PROMO_CODE}`);
    params.push(`sum=${total || itemsSum}`);
    if (order?.number || order?.id) {
        params.push(`orderNumber=${order.number || order.id}`);
    }

    return params.join('&');
};

export default function TinkoffCreditButton({ order }) {
    const ref = useRef(null);

    useEffect(() => {
        let cancelled = false;
        const el = ref.current;
        if (!el || !order || !HAS_CREDENTIALS) return undefined;

        el.setAttribute('shopId', SHOP_ID);
        el.setAttribute('showcaseId', SHOWCASE_ID);
        el.setAttribute('ui-data', 'view=newTab&useReturnLinks=true');
        el.setAttribute('payment-data', buildPaymentData(order));

        loadScript().catch((e) => {
            if (!cancelled) console.error('[TinkoffCreditButton]', e.message);
        });

        return () => {
            cancelled = true;
        };
    }, [order]);

    if (!order || !HAS_CREDENTIALS) return null;

    return (
        <div className="tinkoff-credit-button-wrapper">
            <tinkoff-create-button ref={ref} />
            {IS_TEST && (
                <div className="tinkoff-credit-test-note">
                    Тестовый режим Т-Рассрочки
                </div>
            )}
        </div>
    );
}
